import { useRef, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { useChatbotDialogContext } from 'pages/chatbot/context'
import styles from 'pages/chatbot/ui/ChatbotDialog/styles.module.scss'
import { DialogHeader } from 'pages/chatbot/ui/ChatbotDialog/DialogHeader'
import { DialogList } from 'pages/chatbot/ui/ChatbotDialog/DialogList'
import { AgentTestButton } from 'pages/chatbot/ui/ChatbotButtons'
import { useAgentAppointmentBooked } from 'pages/chatbot/pages/agentBookAppointment/events/useAgentAppointmentBooked'
import { AgentMessageBox } from './AgentMessageBox'
import { DialogEmpty } from '../DialogEmpty'

export const AgentDialog = observer(() => {
  const ref = useRef<HTMLDivElement | null>(null)
  const { started, loading, checkAppointment } = useChatbotDialogContext()
  const isActiveState = started || loading

  useAgentAppointmentBooked((data) => {
    checkAppointment(data)
  })

  useEffect(() => {
    if (!ref.current) return

    ref.current.scrollTo({
      top: ref.current.scrollHeight,
      behavior: 'smooth',
    })
  }, [loading])

  return (
    <div ref={ref} className={styles.dialog}>
      <DialogHeader />
      {isActiveState ? (
        <>
          <DialogList />
          <AgentMessageBox />
        </>
      ) : (
        <DialogEmpty buttonComponent={<AgentTestButton />} />
      )}
    </div>
  )
})
